import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Notification, NotificationBackend } from './notification.interfaces';
import { defaultSelectors, defaultDispatchers } from './notifications.slice';
import { ReduxRepository } from '../reduxRepository';
import { NotificationTranslator } from './notification.translator';
import { createNotificationThunk } from './notificationCreate.thunk';
import { updateNotificationThunk } from './notificationUpdate.thunk';
import { deleteNotificationThunk } from './notificationDelete.thunk';
import { store } from '../../store';
import { loadNotificationsThunk } from './notificationsLoad.thunk';

@injectable()
export class NotificationRepository extends ReduxRepository<
  Notification,
  NotificationBackend
> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<NotificationBackend>,
  ) {
    super(
      ModelTypes.Notification,
      new NotificationTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createNotificationThunk,
      updateNotificationThunk,
      deleteNotificationThunk,
      loadNotificationsThunk,
    );
  }

  getNotification(id: string) {
    return this.selectors
      .resourcesSelector(store.getState())
      .find((notification) => notification.id === id);
  }

  getNotificationByAccount(accountId: string) {
    return this.selectors
      .resourcesSelector(store.getState())
      .find((notification) => notification.accountId === accountId);
  }

  update(notificationId: string, partialNotification: Partial<Notification>) {
    this.dispatchUpdate({
      ...partialNotification,
      id: notificationId,
    });
  }
}
